export const API_URI =
  process.env.REACT_APP_API_URI || 'https://api-v2.antoree.com';
export const CHAT_BACKEND_URL =
  process.env.REACT_APP_CHAT_BACKEND_URL || 'https://educloud.antoree.com';
export const API_SERVICE_URL =
  process.env.REACT_APP_API_SERVICE_URL || 'https://educloud.antoree.com';
export const API_V3_URL =
  process.env.REACT_APP_API_V3_URL || 'https://educloud.antoree.com';
export const MARKET_API_URL =
  process.env.REACT_APP_MARKET_API_URL || 'https://market-api.antoree.com';
export const MEET_URL =
  process.env.REACT_APP_MEET_URL || 'https://meet.antoree.com';
export const PUBLIC_URL = process.env.PUBLIC_URL || '/';
export const NODE_ENV = process.env.NODE_ENV || 'development';
export const { REACT_APP_CHAT_BACKEND_URL } = process.env;
